import { supabase } from "@/integrations/supabase/client";

export type AdminCustomerDataset =
  | "domains"
  | "managedSites"
  | "alerts"
  | "notifications"
  | "profile"
  | "loginContainmentAlerts";

export type AdminCustomerDataProxyResponse = {
  domains?: Array<Record<string, unknown>>;
  managedSites?: Array<Record<string, unknown>>;
  alerts?: Array<Record<string, unknown>>;
  notifications?: Array<Record<string, unknown>>;
  profile?: Record<string, unknown> | null;
  loginContainmentAlerts?: Array<Record<string, unknown>>;
  error?: string;
};

export type AdminCustomerIdentity = {
  id: string;
  email: string | null;
  fullName: string | null;
  companyName: string | null;
  error?: string;
};

const assertFunctionResult = <T extends { error?: string }>(
  data: T | null,
  error: Error | null,
  fallbackMessage: string,
) => {
  if (error) throw error;
  if (!data) throw new Error(fallbackMessage);
  if (data.error) throw new Error(data.error);
  return data;
};

export const fetchAdminCustomerDatasets = async (
  targetUserId: string,
  datasets: AdminCustomerDataset[],
) => {
  const { data, error } = await supabase.functions.invoke("admin-customer-data-proxy", {
    body: { targetUserId, datasets },
  });

  return assertFunctionResult(
    (data ?? null) as AdminCustomerDataProxyResponse | null,
    error,
    "Unable to load customer data.",
  );
};

export const fetchAdminCustomerIdentity = async (targetUserId: string) => {
  const { data, error } = await supabase.functions.invoke("admin-customer-identity", {
    body: { targetUserId },
  });

  return assertFunctionResult(
    (data ?? null) as AdminCustomerIdentity | null,
    error,
    "Unable to load customer identity.",
  );
};
